module.exports = __webpack_public_path__ + "static/media/Norecentplans.441cfaef.png";